import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Component, ContentChild, ContentChildren, Directive, ElementRef, HostListener, Inject, Input, OnInit, Output, PLATFORM_ID, QueryList, Renderer2, EventEmitter } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Directive({
  selector: 'img[fullSizedImage]'
})
export class FullSizedImageDirective {
    
  @Output() imageLoad = new EventEmitter<void>();
  @Output() imageError = new EventEmitter<void>();
  
  @HostListener('load') onLoad() {
    this.imageLoad.emit();
  }

  @HostListener('error') onError() {
    this.imageError.emit();
  }
}

@Component({
  selector: 'img-with-placeholder',
  templateUrl: './img-with-placeholder.component.html',
  styleUrls: ['./img-with-placeholder.component.scss']
})
export class ImageWithPlaceholderComponent implements OnInit {
  
  @Input('placeholder') placeholder: string;
  @Input('priority') priority: boolean = true;
  
  @ContentChild(ElementRef, { read: ElementRef }) contentRef!: ElementRef;
  @ContentChild('img', { read: ElementRef }) directImgElement!: ElementRef; // Direct <img>
  @ContentChildren('img', { descendants: true, read: ElementRef }) allImgElements!: QueryList<ElementRef>; // Any <img>, including inside <picture>
  @ContentChild(FullSizedImageDirective) fullSizedImage!: FullSizedImageDirective;
  
  showFullImage: boolean = false;
  
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object) {
  }
  
  ngOnInit(): void {
    
    console.log('Setting low res placeholder from ' + this.placeholder);
    
    if (this.priority) {
      this.injectPreloadLink();
    }
  }
  
  ngAfterContentInit() {
    if (this.contentRef) {
      const tagName = this.contentRef.nativeElement.tagName.toLowerCase();
      if (tagName !== 'picture' && tagName !== 'img') {
        throw new Error(
          `Invalid child: Only <picture> or <img> tags are allowed, but got <${tagName}>`
        );
      }
    }
    
    firstValueFrom(this.fullSizedImage.imageLoad).then(() => {
      this.onFullSizeImageLoaded();
    });
  }
  
  private injectPreloadLink() {
    const link = this.document.createElement('link');
    link.setAttribute('rel', 'preload');
    link.setAttribute('as', 'image');
    link.setAttribute('href', this.placeholder);
    this.document.head.appendChild(link);
  }
  
  onFullSizeImageLoaded() {
    console.log("Full size image loaded, removing temporary placeholder");
    this.showFullImage = true;
  }
}